/* eslint-disable no-restricted-syntax */

import type {
  CardProWiringProviderInterface,
  LedgerData,
  SearchLedgersProviderInterface,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import { GraphQLClient } from "graphql-request";

import { SearchAccountsProvider } from "@/api/graphql/accounts/searchAccounts/api";
import { SearchWalletProvider } from "@/api/graphql/divisions/getSupportsAndDivisions/api";
import { SearchLedgerTypesProvider } from "@/api/graphql/ledgers/search/api";
import { sleepValue } from "@/utils/core/sleep";

function generateFakeId(id: string): string {
  return `fake-id-${id}`;
}
export class CardProGraphQLProvider implements CardProWiringProviderInterface {
  public accounts: SearchAccountsProvider;
  public wallets: SearchWalletProvider;
  public ledgerTypes: SearchLedgerTypesProvider;

  constructor(graphqlClient: GraphQLClient) {
    this.accounts = new SearchAccountsProvider(graphqlClient);
    this.wallets = new SearchWalletProvider(graphqlClient);
    this.ledgerTypes = new SearchLedgerTypesProvider(graphqlClient);
  }

  //TODO : remove from CardProWiringProviderInterface and then here
  ledgers: SearchLedgersProviderInterface = {
    async search(pan: string): Promise<LedgerData | null> {
      await sleepValue(pan);
      if (pan.includes("1")) {
        return {
          accountId: generateFakeId("1"),
          ledgerId: generateFakeId("3"),
          accountLabel: "Account 1",
          shortCode: "1",
        };
      } else {
        return {
          accountId: generateFakeId("2"),
          ledgerId: generateFakeId("4"),
          accountLabel: "Account 2",
          shortCode: "2",
        };
      }
    },
  };
}
